import { Extension } from '@tiptap/core';
import Suggestion, { type SuggestionOptions } from '@tiptap/suggestion';
import { searchEmoji } from '../emoji-popup';

export type EmojiSuggestionHit = { id: string; native: string; shortcodes: string };

export function buildEmojiSuggestionExtension(renderPopup: SuggestionOptions['render']) {
  return Extension.create({
    name: 'emojiSuggestion',
    addProseMirrorPlugins() {
      return [
        Suggestion({
          editor: this.editor,
          char: ':',
          startOfLine: false,
          allowSpaces: false,
          items: async ({ query }) => {
            if (!query || query.length < 2) return [];
            return searchEmoji(query);
          },
          command: ({ editor, range, props }) => {
            const hit = props as EmojiSuggestionHit;
            editor
              .chain()
              .focus()
              .deleteRange(range)
              .insertContent({ type: 'emoji', attrs: { unicode: hit.native, shortcode: `:${hit.id}:` } })
              .insertContent(' ')
              .run();
          },
          render: renderPopup,
        }),
      ];
    },
  });
}
